export default __webpack_public_path__ + "static/media/phone-featured-light.e401b1a0.jpg";